import { PropOptions } from 'vue'

export interface GoogleRowAd {
  google?: GoogleAd
}

export type RowsAds = Record<number, GoogleRowAd>

export interface RowAdComponentProps {
  sticky?: boolean
  lazy?: boolean
  unit?: string
  containerSize?: [number, number]
}

export interface GoogleAd {
  path: string
  sizes: any[]
  id: string
  sizesMappings?: any[]
  componentProps?: RowAdComponentProps
}

export interface AdsTargeting {
  name: string
  value: string[]
}

export const containerSizeProp: PropOptions<number[]> = {
  type: Array,
  required: false,
  default() {
    return [0, 0]
  }
}

export const containerSizeMappingProp: PropOptions<number[]> = {
  type: Array,
  required: false,
  default() {
    return []
  }
}

export const placeholderProp: PropOptions<boolean> = {
  type: Boolean,
  default: true
}

export interface BackendAdsConfig {
  disabled: boolean
}

export interface AdContainerSizeCssRules {
  'min-height'?: string
  'min-width'?: string
  height?: string
  width?: string
  left?: string
  top?: string
}
